import request from './request'
import { parseURL } from '@/utils/index'

//获取微信openId
export function getOpenid(code){
    let data = {
      code
    }
    return request({
        url:'user/wechat/get/openid',
        method:'post',
        data
    })
}

//获取公众号jsApiTicket
export function getTicket() {
    return request({
        url:'user/wechat/get/ticket',
        method:'post',
        data: {}
    })
}

export function getOpenidOauthUrl() {
     let {
        protocol,
        port,
        host,
        params,
        path,
        query
     } = parseURL();
     delete params.code;
     
     //只能用默认端口号去微信授权
     let redirect_uri = `${protocol}://${host}${path}?`;
      Object.entries(params).forEach(item => {
         redirect_uri += `${item[0]}=${item[1]}&`
      })
     redirect_uri = redirect_uri.substr(0,redirect_uri.length-1);
     let oauthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.APPID}&redirect_uri=${encodeURIComponent(redirect_uri)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
     return oauthUrl;
}

//上传头像
export function photoUpload(data) {
    return request({
        url:'mid/user/profile/photo/upload?appId=1000',
        method:'post',
        data
    })
}

// 获取用户房屋产权信息
export function getUserHouseInfo(data) {
    return request({
        url: 'mid/user/propertyauth/myhouse/list',
        method: 'post',
        data
    })
}



export function getQuestionaireUrl(data){
    return request({
        url: 'biz/mob/message/satisfaction/url',
        method: 'post',
        data
    })
}


//获取四格用户信息
export function getSegiuUserInfo(data) {
    return request({
        url:'charge/common/queryUserInfo',
        method:'post',
        data
    })

}


// WEBPACK FOOTER //
// ./src/api/user.js